export default function Alert({children, variant = 'primary' }) {

  return(
    <div className={`notification is-${variant}`}>
      {children}
    </div>
  )

}
